import styled from 'styled-components';

const Spacing = styled.div`
  padding-top: ${({ size }) => size || 1}px;
`;

export default Spacing;
